import { Box, Typography } from "@mui/material";
import React from "react";
import RenderLogo from "./RenderLogo";
import WelcomeToCoded from "Assets/Images/WelcomeToCoded.png";
import { useSelector } from "react-redux";

const ReferralFooter = () => {

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Footer || {},
  }));

  return (
    <Box
      sx={(theme) => ({
        background: theme.palette.secondary.main,
        padding: "16px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& img": {
          width: "100%",
          maxWidth: "300px",
        },
      })}
    >
      <Box>
        <RenderLogo type="white" />
        <Typography
          display={"flex"}
          mt="16px"
          variant="subtitle"
          fontWeight={500}
          color="white"
        >
          {Translation?.CodedUltimateDestination}
        </Typography>
      </Box>
      <img src={WelcomeToCoded} alt="Welcome to Coded Plus" />
    </Box>
  );
};

export default ReferralFooter;
